import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDefaultNps } from 'components/KBQSelect'

const initialState: SelectedDefaultNps[] = []
const selectedNps = createSlice({
  name: 'SelectedNps',
  initialState,
  reducers: {
    setSelectedNps(state, action: PayloadAction<SelectedDefaultNps>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})
export const { setSelectedNps } = selectedNps.actions
export default selectedNps.reducer
